export function parseEnumValue<T>(
  enumObj: T,
  key?: string | number
): T[keyof T] | number | undefined {
  if (typeof key === 'string') {
    return enumObj[key as keyof T];
  }
  else if (typeof key === 'number') {
    return key;
  }
  
  return undefined;
}
